import '@/lib/typedef';
import client from '@/lib/http-client';

const endpoint = '/receipt-numbers';

export default {
	getLabelData(params, cb, errorCb) {
		const url = `${endpoint}/label_data`;
		client.post(url, params)
			.then((response) => {
				if (cb) cb(response.data);
			})
			.catch((e) => {
				if (errorCb) errorCb(e);
			});
	},
};
